import { Injectable } from '@angular/core';
import { Constants } from '../../../app.constants';
import { BaseService } from '../../../shared/base/base.service';
import { RegistrationsRequests } from './registrations-requests.models';

@Injectable({
  providedIn: 'root'
})
export class RegistrationsRequestsService extends BaseService {

  private url = `${Constants.contextPath}/registration-requests/`;
  
  public approveRegistration(registrationRequest: RegistrationsRequests, partnerId: string, onSuccess: Function) {    
    this.patch(`${this.url}${registrationRequest.id}/approve/${partnerId}`, null, () => onSuccess());
  }

  public rejectRegistration(registrationRequest: RegistrationsRequests, note: string, onSuccess: Function) {
    // Odbij @PatchMapping(path = "/{id}/decline")
    this.patch(`${this.url}${registrationRequest.id}/decline${note ? `?note=${note}` : ''}`, '', (res) => onSuccess(res))
  }
}
